/** Hardcoded badge name -> unlock criteria copy for Trophy Cabinet tooltips. */
export const REWARD_TOOLTIPS: Record<string, string> = {
  'bronze slipper': 'First day recorded',
  'ninja shoes': 'First activity tracked',
  'shoe of the week': 'First week recorded',
  'bronze runner': 'First 10,000 steps',
  'silver shoe': '20,000 steps',
  'astro boots': '40,000 steps',
  'balling shoes': 'Ten days recorded',
  'ruby red slippers': '60,000 steps',
  'rocket boots': '100,000 steps',
  'golden socks': '200,000 steps',
  'ultimate ace': '300,000 steps',
  'top dog': 'Top score for the day',
  'tracking hero': 'Full week recorded',
  'elastic adventurer': 'Tracked more than 4 different activities'
};

export const getRewardTooltip = (rewardName: string): string | undefined => {
  const normalizedName = rewardName.trim().toLowerCase();
  const matchingKey = Object.keys(REWARD_TOOLTIPS)
    .sort((a, b) => b.length - a.length)
    .find(key => normalizedName.includes(key));

  return matchingKey ? REWARD_TOOLTIPS[matchingKey] : undefined;
};
